var _g, _g2, _g3, _path, _path2, _defs;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCreatives(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 102,
    viewBox: "0 0 246 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_32942_15262)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.711,
    y: 4,
    width: 54.5769,
    height: 54.5769,
    rx: 13.2308,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.124,
    y: 4.41346,
    width: 53.75,
    height: 53.75,
    rx: 12.8173,
    stroke: "var(--primary-2)",
    strokeWidth: 0.826923
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.095 16.1895H212.817L215.779 19.6954L216.958 21.0922H221.237L218.275 17.5863L217.095 16.1895ZM225.515 21.0922H230.101C230.069 18.3791 227.86 16.1895 225.14 16.1895H221.374L224.463 19.847L225.515 21.0922ZM212.68 21.0922L208.805 16.5045C206.942 17.2038 205.612 18.9911 205.588 21.0922H212.68ZM205.587 24.3608H230.101V34.1075C230.101 36.8477 227.88 39.0691 225.14 39.0691H210.549C207.809 39.0691 205.587 36.8477 205.587 34.1075V24.3608ZM220.552 32.8038L216.817 35.5259C215.893 36.1988 214.575 35.5586 214.575 34.437V28.9928C214.575 27.8712 215.893 27.231 216.817 27.904L220.552 30.6261C221.299 31.1705 221.299 32.2593 220.552 32.8038ZM200.12 35.166L203.544 24.0621V34.1663C203.544 38.0023 206.654 41.1119 210.49 41.1119H223.939L223.544 42.3914C222.746 44.9788 220.002 46.4294 217.414 45.6313L203.359 41.296C200.772 40.4979 199.321 37.7534 200.12 35.166Z",
    fill: "var(--primary-7)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_32942_15262)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.71094,
    y: 4,
    width: 54.5769,
    height: 54.5769,
    rx: 13.2308,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.1244,
    y: 4.41346,
    width: 53.75,
    height: 53.75,
    rx: 12.8173,
    stroke: "var(--primary-2)",
    strokeWidth: 0.826923
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3773 17.7535C22.4292 17.9392 21.5783 18.577 21.1637 19.4125C21.1484 19.4433 21.1339 19.4719 21.12 19.4993C21.0918 19.5547 21.0664 19.6047 21.0434 19.6558C20.8286 20.1342 20.8286 20.709 20.8292 26.6607C20.8292 26.9753 20.8293 27.305 20.8293 27.6505V34.9575L20.9605 35.3675C21.2945 36.4106 22.2501 37.2729 23.3109 37.4885C23.5192 37.5308 26.7519 37.5453 33.6285 37.5347L43.6428 37.5193L43.996 37.3884C44.7331 37.1152 45.3602 36.5772 45.7152 35.9134C45.7324 35.8813 45.7487 35.8513 45.7644 35.8227C45.7998 35.7579 45.8314 35.6999 45.8598 35.6403C46.1009 35.1335 46.1009 34.5119 46.101 28.6031C46.101 28.2961 46.101 27.9749 46.101 27.6388C46.1016 22.6782 46.0821 20.4004 46.0369 20.1862C45.857 19.3323 45.1658 18.4316 44.3982 18.0509C44.3595 18.0317 44.3245 18.0136 44.2913 17.9964C44.2464 17.9732 44.205 17.9517 44.1628 17.932C43.657 17.6948 43.0398 17.6952 35.0223 17.7005C34.5273 17.7009 34.004 17.7012 33.4508 17.7015C28.0407 17.7045 23.5076 17.7279 23.3773 17.7535ZM33.365 21.1016L35.4868 21.5277L33.514 34.1332L31.3922 33.7071L33.365 21.1016ZM38.697 22.7727L43.4756 27.5707L38.697 32.3687L37.1684 30.8339L40.4184 27.5707L37.1684 24.3075L38.697 22.7727ZM28.2272 22.7727L29.7558 24.3075L26.5058 27.5707L29.7558 30.8339L28.2272 32.3687L23.4486 27.5707L28.2272 22.7727ZM15.9068 36.8644C15.9267 36.5901 16.3671 35.0645 17.4692 31.4509L19.0039 26.4193L19.0355 30.9C19.0662 35.249 19.0708 35.3936 19.1936 35.8227C19.7009 37.5949 20.9862 38.844 22.7236 39.2533C23.1982 39.3651 23.4608 39.3681 32.6812 39.3685C41.6732 39.3689 42.1497 39.374 42.1186 39.4708L41.4915 41.4296C41.1646 42.4509 40.8257 43.4154 40.7385 43.5729C40.405 44.1749 39.6419 44.7371 38.9435 44.8952C38.5626 44.9813 37.8963 44.9721 37.519 44.8754C37.3411 44.8297 32.8491 43.6499 27.5368 42.2535C20.1603 40.3145 17.778 39.6668 17.4547 39.5125C16.4762 39.0454 15.8286 37.9375 15.9068 36.8644Z",
    fill: "var(--primary-7)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_32942_15262)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.4219,
    y: 43.4238,
    width: 54.5769,
    height: 54.5769,
    rx: 13.2308,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8353,
    y: 43.8373,
    width: 53.75,
    height: 53.75,
    rx: 12.8173,
    stroke: "var(--primary-2)",
    strokeWidth: 0.826923
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.186 57.1771C114.242 57.362 113.394 57.997 112.982 58.829C112.633 59.5319 112.649 59.1415 112.649 67.0316V74.3073L112.779 74.7155C113.112 75.7542 114.063 76.6128 115.12 76.8274C115.327 76.8696 118.546 76.884 125.393 76.8735L135.364 76.8581L135.716 76.7278C136.45 76.4557 137.074 75.92 137.428 75.2591C137.829 74.5092 137.811 74.8913 137.812 67.0199C137.813 62.0807 137.793 59.8127 137.748 59.5993C137.569 58.7492 136.881 57.8523 136.116 57.4732C135.363 57.0995 135.982 57.1193 125.216 57.1253C119.829 57.1283 115.315 57.1516 115.186 57.1771ZM135.103 59.7805L135.276 59.9499V64.4589C135.276 66.9438 135.253 68.9432 135.226 68.9128C135.198 68.8825 134.3 67.8534 133.23 66.6258C132.16 65.3982 131.187 64.3092 131.066 64.2057C130.258 63.5118 129.028 63.5079 128.226 64.1968C128.1 64.3052 126.937 65.6422 125.642 67.1679L123.287 69.942L123.071 69.7489C122.953 69.6427 122.537 69.2498 122.148 68.8759C121.236 68.0006 120.981 67.8713 120.171 67.8743C119.244 67.8777 119.231 67.887 117.029 70.038L115.156 71.8683V65.966C115.156 60.5563 115.164 60.05 115.255 59.8998C115.309 59.8096 115.408 59.7096 115.476 59.6774C115.557 59.6388 118.891 59.6175 125.265 59.6149L134.931 59.611L135.103 59.7805ZM118.298 60.918C117.825 61.0431 117.524 61.2171 117.161 61.5748C116.196 62.5253 116.173 64.0012 117.107 64.9724C117.623 65.5083 118.2 65.7562 118.932 65.7562C119.659 65.7562 120.242 65.508 120.748 64.9825C121.115 64.6006 121.277 64.2944 121.388 63.7685C121.76 62.0167 120.063 60.4511 118.298 60.918ZM109.173 70.8582C108.076 74.4563 107.638 75.9753 107.618 76.2485C107.54 77.317 108.185 78.4201 109.159 78.8852C109.481 79.0389 111.853 79.6838 119.198 81.6145C124.487 83.0049 128.96 84.1796 129.137 84.2251C129.513 84.3214 130.176 84.3306 130.556 84.2448C131.251 84.0874 132.011 83.5277 132.343 82.9282C132.43 82.7713 132.767 81.8111 133.093 80.7941C133.418 79.7772 133.699 78.8995 133.717 78.8437C133.748 78.7473 133.274 78.7422 124.32 78.7418C115.139 78.7414 114.878 78.7384 114.405 78.6271C112.675 78.2196 111.396 76.9758 110.89 75.2112C110.768 74.784 110.764 74.64 110.733 70.3097L110.702 65.8482L109.173 70.8582Z",
    fill: "var(--primary-7)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2102 71.3428L82.741 71.3426C79.5442 71.3425 76.9527 68.751 76.9527 65.5541L76.9526 45.789C76.9525 42.5921 74.361 40.0005 71.1641 40.0005L61.71 40.0005",
    stroke: "var(--primary-3)",
    strokeWidth: 0.826923
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.262 71.3428L162.732 71.3426C165.928 71.3425 168.52 68.751 168.52 65.5541L168.52 45.789C168.52 42.5921 171.112 40.0005 174.309 40.0005L184.211 40.0005",
    stroke: "var(--primary-3)",
    strokeWidth: 0.826923
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_32942_15262",
    x: 184.403,
    y: 0.692308,
    width: 61.1916,
    height: 61.1916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.826923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.826923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.30769,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.897346 0 0 0 0 0.861279 0 0 0 0 1 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_32942_15262",
    result: "effect2_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32942_15262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_32942_15262",
    x: 0.403245,
    y: 0.692308,
    width: 61.1916,
    height: 61.1916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.826923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.826923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.30769,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.897346 0 0 0 0 0.861279 0 0 0 0 1 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_32942_15262",
    result: "effect2_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32942_15262",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_32942_15262",
    x: 92.1142,
    y: 40.1161,
    width: 61.1916,
    height: 61.1916,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.826923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.826923
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.30769,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.897346 0 0 0 0 0.861279 0 0 0 0 1 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_32942_15262",
    result: "effect2_dropShadow_32942_15262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_32942_15262",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatives);
export default __webpack_public_path__ + "static/media/creatives.26cf8ef873c18066e114feb6f8686e6b.svg";
export { ForwardRef as ReactComponent };